import { Environment } from '../types/app';
import EnvVars from '../constants/env';

/**
 * Get API endpoints based on environment
 * @param env - environment (dev/stg/prd)
 * @returns object containing httpUrl and uploadUrl
 */
export const getApiEndpoints = (env: Environment) => {
  const envConfig = EnvVars[env];
  
  return {
    httpUrl: envConfig.REACT_APP_USERPROFILE_SERVICE_APIGEEX,
    uploadUrl: envConfig.REACT_APP_USERPROFILE_SERVICE_APIGEEX,
  };
};
